import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'
import { hawkService } from './services/hawkService'

// Инициализируем Hawk для отслеживания ошибок
// Hawk автоматически перехватывает необработанные ошибки и отклоненные промисы
hawkService.init({
  consoleTracking: import.meta.env.MODE === 'production',
  debug: import.meta.env.MODE === 'development',
});

// Проверяем инициализацию Hawk
if (hawkService.isReady()) {
  if (import.meta.env.MODE === 'development') {
    console.log('✅ Hawk готов к работе. Для теста используйте: window.hawkService.catch(new Error("Test"))');
  } else {
    console.log('✅ Hawk готов');
  }
} else {
  if (import.meta.env.MODE === 'development') {
    console.warn('⚠️ Hawk не инициализирован. Проверьте переменные окружения.');
  } else {
    console.warn('⚠️ Hawk не инициализирован');
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
) 
